import React from 'react';
import { connect } from 'react-redux';

// import Grid from '@mui/material/Grid';
// import DistributorIcon from '@mui/icons-material/LanguageOutlined';

import { DistributorsTableContainer } from '../../components/distributors';
// import StatsBox from '../../components/shared/StatsBox';

import { fetchDistributors } from '../../actions/adminActions';

import './admin.scss';

const DistributorsPage = ({ distributors, countries, companies }) => {
  return (
    <div className="admin-page">
      {/*<Grid container spacing={3} sx={{ mb: 3 }}>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Distributors' number={distributors?.length} icon={<DistributorIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Distributors' number={distributors?.length} icon={<DistributorIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Distributors' number={distributors?.length} icon={<DistributorIcon />} />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}
      <DistributorsTableContainer
        distributors={distributors}
        countries={countries}
        companies={companies}
        withButton
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    distributors: state.distributors?.list || [],
    countries: state.countries.list,
    companies: state.companies.list,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchDistributors: () => dispatch(fetchDistributors()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DistributorsPage);
